import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  label?: string;
  options: {
    label: string;
    value: string;
  }[];
};

const RHFRadioGroup = ({ name, label, options }: Props) => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl error={!!errors[name]}>
      {label && <InputLabel shrink>{t(label)}</InputLabel>}

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup {...field}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={t(option.label)}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                  },
                }}
              />
            ))}
          </RadioGroup>
        )}
      />

      <FormHelperText>
        {t((errors[name]?.message as string) || "")}
      </FormHelperText>
    </FormControl>
  );
};

export default RHFRadioGroup;
